/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationDataSchema = z.object({
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	privacyPolicyUrl: z.string().url().nullable().optional(),
	organisationInformation: z.object({
		legalEntityName: z.string().nullable().optional(),
		streetAddress: z.string().nullable().optional(),
		postalCode: z.string().nullable().optional(),
		city: z.string().nullable().optional(),
		country: z.string().nullable().optional(),
		phoneNumber: z.string().nullable().optional(),
		emailAddress: z.string().email().nullable().optional(),
	}).nullable().optional(),
	dataProtectionOfficer: z.object({
		name: z.string().nullable().optional(),
		phoneNumber: z.string().nullable().optional(),
		emailAddress: z.string().email().nullable().optional(),
	}).nullable().optional(),
	careerSiteEnabled: z.boolean().nullable().optional(),
})

export type UpdateOrganisationDataSchema = z.infer<typeof updateOrganisationDataSchema>
